<div class="chat-input">
  <textarea
    #messageInput
    [(ngModel)]="newMessage"
    [attr.placeholder]="t.PLACEHOLDER_ASK_QUESTION"
    rows="3"
    (keydown)="onKeydown($event)"
    [disabled]="isLoading"
  ></textarea>
  <button
    type="button"
    (click)="sendMessage()"
    [disabled]="isLoading"
    class="send-icon"
  >
    <i class="bi bi-send"></i>
  </button>
  <div *ngIf="isLoading" class="loading-dots">
    <span>.</span><span>.</span><span>.</span>
  </div>
</div>
